import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingPaymentCuponComponent } from './waiting-payment-cupon.component';
import { DisabledInputModule } from '@app/core/components/disabled-input/disabled-input.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { RsDownloadIconModule } from '../../../../../../../../../../libs/rs-download-icon/src/index';
import { RsCopyModule } from '../../../../../../../../../../libs/rs-copy/src';

@NgModule({
    declarations: [WaitingPaymentCuponComponent],
    exports: [WaitingPaymentCuponComponent],
    imports: [
        CommonModule,
        DisabledInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        RsDownloadIconModule,
        RsCopyModule,
        ContentLoaderModule
    ]
})
export class WaitingPaymentCuponModule {}
